'use strict';
import $ from 'jquery';

var mediator = require('../mediator'),
  config = require('../config'),
  ModalView = require('./ModalView'),
  ShareLink = require('../../components/ShareLink/ShareLink'),
  shareModalTemplate = require('../../tmpl/client/modal/shareModal.hbs'),

  ShareModalView = ModalView.extend({
    template: shareModalTemplate,

    events: {
      'click .Share-link': 'close'
    },

    initialize: function() {
      ShareModalView.__super__.initialize.apply(this);

      mediator.on(config.events.share.modal, this.open);
    },

    initializeElements: function() {
      const FOCUSABLE_ELEMENT_SELECTORS = 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, [tabindex="0"], [contenteditable]';
      const focusableElements = document.getElementById('ShareModalDialog').querySelectorAll(FOCUSABLE_ELEMENT_SELECTORS);
      this.$lastElement = $(focusableElements[focusableElements.length - 1]);
      this.$firstElement = $(focusableElements[0]);
      this.$lastActiveElement = $(document.activeElement);
    },

    open: function(data) {
      data.shareLinkEncoded = encodeURIComponent(data.shareLink);
      ShareModalView.__super__.open.call(this, data);
    },

    onOpen: function() {
      // Open the share dialog
      ShareLink.create(this.$el);
      this.initializeElements();
      this.$('.Modal-dialog').attr('aria-modal',true);
      document.getElementById('ShareModalDialog').focus();
      this.$firstElement.on('keydown',(e)=>{
        if (e.key === 'Tab' && e.shiftKey) {
          e.preventDefault();
          this.$lastElement.focus();
        }
      });
      this.$lastElement.on('keydown', (e)=>{
        if (e.key === 'Tab' && !e.shiftKey) {
          e.preventDefault();
          this.$firstElement.focus();
        }
      });
    },

    onClose() {
      this.$('.Modal-dialog').removeAttr('aria-modal');
      this.$lastActiveElement.focus();
    }

  });

module.exports = new ShareModalView();



// WEBPACK FOOTER //
// ./assets/js/components/ShareModalView.js